// AUTO-GENERATED from `oak_medium.json` — do not edit by hand. Regenerate via the preset
//   → `.ts` conversion script when the upstream preset JSONs change.
import type {DeepPartial, TreeOptions} from "../options.js";

const options: DeepPartial<TreeOptions> = {
    "seed": 35729,
    "type": "deciduous",
    "bark": {
      "type": "Bark001",
      "tint": 16774097,
      "flatShading": false,
      "textured": true,
      "textureScale": {
        "x": 1,
        "y": 10
      }
    },
    "branch": {
      "levels": 3,
      "angle": {
        "1": 54,
        "2": 58,
        "3": 32
      },
      "children": {
        "0": 6,
        "1": 4,
        "2": 3
      },
      "force": {
        "direction": {
          "x": 0,
          "y": 1,
          "z": 0
        },
        "strength": 0.02
      },
      "gnarliness": {
        "0": 0,
        "1": -0.1,
        "2": -0.15,
        "3": 0.09
      },
      "length": {
        "0": 37.24,
        "1": 11.08,
        "2": 12.39,
        "3": 7.16
      },
      "radius": {
        "0": 1.41,
        "1": 0.9,
        "2": 0.69,
        "3": 1.19
      },
      "sections": {
        "0": 8,
        "1": 6,
        "2": 3,
        "3": 1
      },
      "segments": {
        "0": 7,
        "1": 5,
        "2": 3,
        "3": 3
      },
      "start": {
        "1": 0.49,
        "2": 0.06,
        "3": 0.12
      },
      "taper": {
        "0": 0.73,
        "1": 0.42,
        "2": 0.69,
        "3": 0.75
      },
      "twist": {
        "0": -0.23,
        "1": 0.42,
        "2": 0,
        "3": 0
      }
    },
    "leaves": {
      "type": "oak",
      "billboard": "double",
      "angle": 42,
      "count": 18,
      "start": 0.16,
      "size": 2.5,
      "sizeVariance": 0.7,
      "tint": 14013901,
      "alphaTest": 0.5
    },
    "trellis": {
      "enabled": false
    }
  };

export default options;
